import BankModal from "./bank-modal.component";

export default BankModal;
